import { Injectable, signal, WritableSignal } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class googleCalendar extends ApiBaseService {
    constructor(public http: HttpClient) {
        super(http, '/calendar');
    }


    getAuthUrl(userId: number, type: string) {
        return this.http.get(`${environment.apiUrl}/calendar/auth-url?userId=${userId}&type=${type}`);
        // return this.http.get<{ url: string }>(`${environment.apiUrl}auth-url?userId=${userId}`);
      }
    
      googleTokens(userId: number) {
        return this.http.get<any[]>(`${environment.apiUrl}/calendar/googleTokens?userId=${userId}`);
      }

      createMeeting(userId: number) {
        return this.http.get<any[]>(`${environment.apiUrl}/calendar/createGoogleMeet?userId=${userId}`);
      }

      listCalendars(userId: number) {
        return this.http.get(`${environment.apiUrl}/calendar/list-calendars`, {
          params: { userId: userId.toString() }
        });
      }
      
     
}
